import { connect } from 'react-redux'
import { translator } from 'mage-i18n'

import NotFound from '../components/NotFound'

const mapStateToProps = state => ({
  t: translator(state)
})

export default connect(mapStateToProps)(NotFound)
